import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import AboutSection from "./components/AboutSection";
import IndustriesSection from "./components/IndustriesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcademySection from "./components/AcademySection";
import CTASection from "./components/CTASection";

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <IndustriesSection />
      <TestimonialsSection />
      <AcademySection />
      <CTASection />
    </main>
  );
}
